import { CompletedReasonEnum } from 'src/models/Session.model';

import {
  LengthOfDiabetesDiagnosisEnum,
  TimeSinceLastEyeExamEnum,
  TypeOfDiabetesEnum,
} from '../DiabetesData.model';
import { ModelEnum } from '../Model.model';
import { DeviceDataValue } from './DeviceDataValue.model';
import { GalenDataUser } from './User.model';

export interface ResultJson {
  results: GradingResults;
}

export interface GradingDetail {
  grading: string;
  conf: number;
}

export interface GradingResults {
  [ModelEnum.GENERAL_QUALITY]: GradingDetail;
}

interface Metadata {
  models: string[];
}

export interface ExamData {
  // When submit the session, the images have not been submitted successfully, the status is undefined.
  Status?: DeviceDataValue<string>;
  IsHidden: DeviceDataValue<boolean>;
  ExamSubmissionDatetime: DeviceDataValue<string>;
  LeftEyeResultJson: DeviceDataValue<ResultJson>;
  RightEyeResultJson: DeviceDataValue<ResultJson>;
  SubmittedForAnalysis: DeviceDataValue<boolean>;
  ReportDatetime: DeviceDataValue<string>;
  LeftImage: DeviceDataValue<string>;
  PracticeUserId: DeviceDataValue<string>;
  SessionId: DeviceDataValue<string>;
  RightImage: DeviceDataValue<string>;
  ExamSubmissionMetadata: DeviceDataValue<Metadata>;
  CompletedTime?: DeviceDataValue<Date>;
  CompletedReason?: DeviceDataValue<CompletedReasonEnum>;
  OrderId: DeviceDataValue<string>;

  // site
  SiteId?: DeviceDataValue<string>;
  SiteName?: DeviceDataValue<string>;

  // diabetes
  DiabetesType?: DeviceDataValue<TypeOfDiabetesEnum>;
  DurationOfDiabetes?: DeviceDataValue<LengthOfDiabetesDiagnosisEnum>;
  LastEyeExam?: DeviceDataValue<TimeSinceLastEyeExamEnum>;
}

export interface DeviceDataView<T> {
  /**
   * The identifier of the device data record.
   */
  deviceDataId?: string;
  /**
   * The identifier of the device data model.
   */
  deviceDataModelId?: string;
  /**
   * The identifier of the owner of this record.
   */
  ownerId?: string;
  /**
   * The name of the owner of this record.
   */
  ownerName?: string;
  /**
   * The full owner object, if requested.
   */
  owner?: GalenDataUser;
  /**
   * The data dictionary with property code as the key.
   */
  // data?: { [key: string]: DeviceDataValue };

  data: T;
  /**
   * The date/time when this record was last updated.
   */
  maxValueProvidedOn?: Date;
  /**
   * The date/time when this record was first created.
   */
  minValueProvidedOn?: Date;
  /**
   * The scope of the datamodel to which this data belongs.
   */
  scope?: DeviceDataViewScopeEnum;
}

export enum DeviceDataViewScopeEnum {
  Patient = 'Patient',
  Practice = 'Practice',
  Supplier = 'Supplier',
  Tenant = 'Tenant',
}

export enum BackendStatusEnum {
  Null = 'Null',
  Failed = 'Failed',
  InitializerStarted = 'InitializerStarted',
  InitializerEnded = 'InitializerEnd',
  ModelsStarted = 'ModelsStarted',
  ReportStarted = 'ReportStarted',
  ReportEnd = 'ReportEnd',
}

export enum ModelStatus {
  NA = 'NA',
  Triggered = 'Triggered',
  Running = 'Running',
  Complete = 'Complete',
  Failed = 'Failed',
}
